import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AGUSortOption } from '../sort-trigger/sort-trigger.component';

/** How many rail groups get a quick chip (P/Member_Hub.html:920, `.slice(0,4)`). */
export const MOBILE_CHIP_GROUPS = 4;

/** An option's text without the closed-trigger "Sort:" prefix (P/Member_Hub.html:928). */
export function StripSortPrefix(label: string): string {
    return label.replace(/^Sort:\s*/, '');
}

/**
 * The phone finder's quick-filter row (`.mchips`, P/Member_Hub.html:915-951, CSS :649-672): one horizontally scrolling line of
 * **Filters [count]** (opens the filter sheet at the top), the sort select (the toolbar's, "Sort:" stripped), and the first four rail
 * group labels, each opening the sheet scrolled to its group. The page owns the sheet: this row only says which group was asked for.
 */
@Component({
    standalone: false,
    selector: 'agu-mobile-chips',
    templateUrl: './mobile-chips.component.html',
    styleUrl: './mobile-chips.component.scss',
})
export class AGUMobileChipsComponent {
    /** Active filter groups — the rail head's count (:908). */
    @Input() FilterCount = 0;
    @Input() SortOptions: readonly AGUSortOption[] = [];
    /** Key of the sort in force. */
    @Input() Sort = '';
    /** The rail's group labels in order; the first four become chips (`Show` and collapsed groups are the page's to leave out, :919). */
    @Input() Groups: readonly string[] = [];
    /** The group labels with at least one active filter; their chips render `.on` (P/Member_Hub.html:653-654, 939-945). */
    @Input() ActiveGroups: readonly string[] = [];

    /** A group label, or null for the sheet's top (the Filters chip). */
    @Output() OpenFilters = new EventEmitter<string | null>();
    @Output() SortChange = new EventEmitter<string>();

    get CountLabel(): string {
        return this.FilterCount > 0 ? String(this.FilterCount) : '';
    }

    /** The Filters chip's name: the prototype's 'All filters' (:924), with the count a sighted member reads off the badge. */
    get FilterAriaLabel(): string {
        return this.FilterCount > 0 ? `All filters, ${this.FilterCount} active` : 'All filters';
    }

    get SelectOptions(): readonly AGUSortOption[] {
        return this.SortOptions.map((option) => ({ Key: option.Key, Label: StripSortPrefix(option.Label) }));
    }

    get VisibleGroups(): readonly string[] {
        return this.Groups.slice(0, MOBILE_CHIP_GROUPS);
    }

    IsActive(group: string): boolean {
        return this.ActiveGroups.includes(group);
    }

    OpenAll(): void {
        this.OpenFilters.emit(null);
    }

    OpenGroup(group: string): void {
        this.OpenFilters.emit(group);
    }

    PickSort(key: string): void {
        if (key === this.Sort) return;
        this.SortChange.emit(key);
    }
}
